import React from "react";
import PropTypes from "prop-types";
import Btn from "../../../../components/atoms/Btn";

function CollapseButton({ isVisible, isCollapsed, toggle }) {
  return isVisible ? (
    <div className="tw-inline-block tw-absolute tw-top-0 tw--left-4 tw-opacity-50">
      <Btn
        className="color-1"
        onSubmit={toggle}
        data-tooltip-class="genome-browser-small-tooltip"
        data-tooltip="Expand / Collapse"
        data-tooltip-delay="700"
      >
        {isCollapsed ? (
          <i className="fa fa-chevron-right tw-ml-0.5" />
        ) : (
          <i className="fa fa-chevron-down" />
        )}
      </Btn>
    </div>
  ) : null;
}

CollapseButton.propTypes = {
  isCollapsed: PropTypes.bool.isRequired,
  isVisible: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

export default CollapseButton;
